import { Planos_mod } from './../../../models/planos_mod.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { FormService } from 'src/app/services/form.service';



@Component({
    selector: "page-planos_mod",
    templateUrl: "./planos_mod.component.html", 
    providers: [FormService]
})

export class Planos_modComponent {
    
    public rows = [];
      public actualRow;
      public planos_mod: Planos_mod;
      public form;
 
      
      matcher = new FormService();
      

    constructor( public _formService: FormService){
        this.form = new FormGroup({
            planos_mod: new FormControl('', Validators.required),

        })

        if(!JSON.parse(localStorage.getItem("planos_mod"))){
            localStorage.setItem("planos_mod", JSON.stringify(this.rows));
        }else{
            
            this.rows = JSON.parse(localStorage.getItem("planos_mod"));
            this.form.controls['planos_mod'].setValue(this.rows[0]?this.rows[0].planos_mod:false)
            
            
        }

        
        

    }


    add_planos_mod(){

    
        localStorage.setItem("planos_mod",JSON.stringify([]));
        this.actualRow = localStorage.getItem("planos_mod");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            planos_mod: this.form.value.planos_mod
        })

        localStorage.setItem("planos_mod", JSON.stringify(this.rows));
        this.form.reset();//

        //this.planos_mod = JSON.parse(localStorage.getItem("planos_mod"));

    }
    delete_planos_mod(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("planos_mod", JSON.stringify(this.rows));
            }
        }
    }
}